
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider, useToast, setGlobalToast } from './components/base/Toast';
import { useEffect } from 'react';

const queryClient = new QueryClient();

function ToastInitializer() {
  const { showToast } = useToast();
  
  useEffect(() => {
    setGlobalToast(showToast);
  }, [showToast]);
  
  return null;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ToastInitializer />
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
